import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomPopoverComponent } from './custom-popover/custom-popover';
import { SettingsService } from '../settings/settings.service';
import { DialogStatus } from './dialog-status/dialog-status';


@Component({
  selector: 'app-ficha-inversionista-cliente',
  imports: [
    CustomPopoverComponent, 
    MatDialogModule,
    MatAutocompleteModule,
    FormsModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule, 
    MatCardModule, 
    MatButtonModule, 
    MatIconModule, 
    MatFormFieldModule, 
    MatInputModule, 
    MatSelectModule, 
    ReactiveFormsModule, 
    CommonModule, 
    MatProgressSpinnerModule
  ],
  templateUrl: './ficha-inversionista-cliente.html',
  styleUrl: './ficha-inversionista-cliente.less',
  standalone: true
})
export class FichaInversionistaCliente implements OnInit, OnDestroy {

  @Input() company_id:any;

  opcion_seleccionada: string="";
  tipo_persona: string[] = ['Persona natural', 'Persona jurídica'];
  formGroup: FormGroup;
  formGroup2: FormGroup;
  formGroup3: FormGroup;
  formGroup4: FormGroup;
  formGroup5: FormGroup;

  //persona jurifica
  valForm: FormGroup;
  valForm2: FormGroup;
  valForm4: FormGroup;

  randomImage: string = '';
  private images: string[] = [
    '/images/33.jpg',
    '/images/3.jpg',
    '/images/4.jpg',
    '/images/7.jpg',
    '/images/9.jpg',
    '/images/12.jpg',
    '/images/14.jpg',
    '/images/17.jpg',
    '/images/23.jpg',
    '/images/2.jpg',
    '/images/15.jpg',
    '/images/26.jpg',
  ];

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    const img = new Image();
    img.src = this.images[randomIndex];
    this.imageLoaded = false;

    img.onload = () => {
      this.randomImage = img.src;
      this.imageLoaded = true;
    };
  }

  imageLoaded: boolean = false;

  verification_code:any;
  constructor(private _formBuilder:FormBuilder, private settings:SettingsService, private dialog:MatDialog, private activatedRoute: ActivatedRoute){


      this.activatedRoute.queryParams.subscribe(params => {
        this.verification_code = params['verification_code'];
      });


    //Persona natural
    this.formGroup = this._formBuilder.group({
      rut: [null, Validators.compose([Validators.required, Validators.pattern('^[0-9]{7,10}[-][0-9Kk]$')])],
      name: [null, [Validators.required]],
      fecha_nacimiento: [null, [Validators.required]],
      nacionalidad: [null, [Validators.required]],
      phone_number: [null, [Validators.required]],
      email: [null, Validators.required],
      direccion: [null, [Validators.required]],
      estado_civil: [null, [Validators.required]],
      region_id: [null, [Validators.required]],
      comuna_id: [null, [Validators.required]],
      phone_code: new FormControl('+56', Validators.required),
      countryFilterCtrl: new FormControl('')
    })

    //Persona juridica
    this.valForm = this._formBuilder.group({
      rut: [null, Validators.compose([Validators.required, Validators.pattern('^[0-9]{7,10}[-][0-9Kk]$')])],
      razon_social: [null, [Validators.required]],
      direccion: [null, [Validators.required]],
      giro: [null, [Validators.required]],
      email: [null, Validators.email],
      region_empresa_id: [null, [Validators.required]],
      comuna_empresa_id: [null, [Validators.required]],
    })

    //persona juridica
    this.valForm2 = this._formBuilder.group({
      'rut': [null, Validators.compose([Validators.required, Validators.pattern('^[0-9]{7,10}[-][0-9Kk]$')])],
      name: [null, [Validators.required]],
      fecha_nacimiento: [null, [Validators.required]],
      nacionalidad: [null, [Validators.required]],
      phone_number: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      direccion: [null, [Validators.required]],
      cargo: [null, [Validators.required]],
      estado_civil: [null, [Validators.required]],
      region_id: [null, [Validators.required]],
      comuna_id: [null, [Validators.required]],
      profesion: [null, [Validators.required]],
      phone_code: new FormControl('+56', Validators.required),
      countryFilterCtrl: new FormControl('')
    })

    //Persona natural
    this.formGroup2 = this._formBuilder.group({
      situacion_laboral: [null , [Validators.required]],
      business_name: [null],
      profesion: [null, [Validators.required]]
    })

    this.formGroup3 = this._formBuilder.group({
      banco_id: [null , [Validators.required]],
      cuenta_id: [null , [Validators.required]],
      rut: [null , [Validators.required]],
      titular: [null , [Validators.required]],
      numero_cuenta: [null , [Validators.required]],
      autorizar_terceros: [null]
    })

    //Persona natural
    this.formGroup4 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [false],
      3: [false],
      4: [false],
      5: [false]
    })

    //Persona juridica
    this.valForm4 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [false],
      3: [false],
      4: [false]
    })


    this.formGroup5 = this._formBuilder.group({
      0: [false],
      1: [false],
      2: [true],
    })
  }

  continuar_origen:boolean=true;
  continuar_declaracion:boolean=true;

  @ViewChild('searchInput') searchInput!: ElementRef;
  private _destroy$ = new Subject<void>();

  async ngOnInit() {

    this.setRandomBackground();

    await this.getPhonePrefix();
    await this.getDistricts();
    await this.estado_civil();
    await this.load_bancos();
    await this.load_cuentas();

    this.formGroup5.controls['2'].setValue(true);

    this.formGroup4.valueChanges.subscribe(val => {
      if(this.getSeleccionados().length > 0){
        this.continuar_origen = false;
      }else{
        this.continuar_origen = true;
      }
    });

    this.valForm4.valueChanges.subscribe(val => {
      if(this.getSeleccionadosJuridicos().length > 0){
        this.continuar_origen = false;
      }else{
        this.continuar_origen = true;
      }
    });

    this.formGroup5.valueChanges.subscribe(val => {
      if(this.getSeleccionados2().length > 0){
        this.continuar_declaracion = false;
      }else{
        this.continuar_declaracion = true;
      }
    });

    this.formGroup.controls['countryFilterCtrl'].valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(value => this.filterCountries(value ?? ''));

    this.valForm2.controls['countryFilterCtrl'].valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(value => this.filterCountries(value ?? ''));

    this.valForm2.controls['email'].valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(email => this.valForm.controls['email'].setValue(email, { emitEvent: false }));

    this.getFicha();

  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private filterCountries(search: string) {
    const term = search.toLowerCase().trim();
    this.filteredCountries = !term
      ? [...this.COUNTRIES]
      : this.COUNTRIES.filter(c =>
          c.name.toLowerCase().includes(term) ||
          c.dialCode.includes(term)
        );
  }

  onSelectOpened(opened: boolean) {
    if (opened) {
      this.formGroup.controls['countryFilterCtrl'].setValue('');
      setTimeout(() => this.searchInput?.nativeElement?.focus(), 100);
    }
  }

  onSelectOpened2(opened: boolean) {
    if (opened) {
      this.valForm2.controls['countryFilterCtrl'].setValue('');
      setTimeout(() => this.searchInput?.nativeElement?.focus(), 100);
    }
  }

  soloNumerosCuenta(): void {
    const control = this.formGroup3.get('numero_cuenta');
    if (!control) return;

    let valor = control.value ?? '';

    valor = valor.toString().replace(/\D+/g, '');

    if (valor.length > 30) {
      valor = valor.substring(0, 30);
    }

    control.setValue(valor, { emitEvent: false });
  }

  getSeleccionados(): string[] {
  const values = this.formGroup4.value; 
  const opciones = [
    "Ahorros personales",
    "Sueldo o ingresos laborales",
    "Venta de bienes",
    "Herencia o donaciones",
    "Rentas de inversiones",
    "Otros"
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  getSeleccionadosJuridicos(): string[] {
  const values = this.valForm4.value; 
  const opciones = [
    "Ventas o ingresos de la empresa",
    "Capitalización de socios",
    "Préstamos o financiamiento",
    "Rentas de inversiones",
    "Otros"
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  getSeleccionados2(): string[] {
  const values = this.formGroup5.value; 
  const opciones = [
    "Ley FATCA",
    "PEP",
    "información actualizada",
  ];

  return Object.keys(values)
    .filter(key => values[key] === true)
    .map(key => opciones[+key]);
  }

  step:any=0;
  substep:any=1;
  continuar(){
    if(this.opcion_seleccionada == 'Persona natural'){
      this.step = 1;
    }else{
      this.step = 2;
    }
  }

  formatPhone(event: any) {
    let input = event.target.value.replace(/\D/g, '');

    this.formGroup.get('phone')?.setValue(input);
  }

  formatPhoneJuridico(event: any) {
    let input = event.target.value.replace(/\D/g, '');

    this.valForm2.get('phone')?.setValue(input);
  }

  formatRUT(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }



    this.formGroup.controls['rut'].setValue(cleaned);
  }

  formatRUT_juridico(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }



    this.valForm.controls['rut'].setValue(cleaned);
  }

  formatRUT_juridico2(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }



    this.valForm2.controls['rut'].setValue(cleaned);
  }

  formatRUT3(input: any) {
    let value = input.target.value.toUpperCase();
    value = value.replace(/[^0-9K]/g, '');
    let numbers = value.replace(/K/g, ''); 
    let k = value.includes('K') ? 'K' : '';
    let cleaned = numbers + k;

    if (cleaned.length > 1) {
      cleaned = cleaned.slice(0, -1) + '-' + cleaned.slice(-1);
    }

    console.log(input)
    console.log(cleaned)

    this.formGroup3.controls['rut'].setValue(cleaned);
  }

  async sendForm($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup.controls) {
      this.formGroup.controls[c].markAsTouched();
    }

    if (this.formGroup.valid) {

      this.substep = 2;
      this.setRandomBackground();



    }else{
      console.log("form invalido")
      console.log(this.formGroup.value)
    }

  }

  async sendFormJuridico($ev:any) {

    $ev.preventDefault();

    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {

      this.substep = 2;
      this.setRandomBackground();



    }else{
      console.log("form invalido")
      console.log(this.valForm.value)
    }

  }

  show_terceros:boolean=false;
  async sendForm2($ev:any) {

    $ev.preventDefault();

    for (let c in this.formGroup2.controls) {
      this.formGroup2.controls[c].markAsTouched();
    }

    if (this.formGroup2.valid) {

      this.substep = 3;
      this.setRandomBackground();


      this.formGroup3.controls['rut'].setValue(this.formGroup.controls['rut'].value)

      if(this.formGroup3.controls['rut'].value != this.formGroup.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }



    }else{
      console.log("form invalido")
      console.log(this.formGroup2.value)
    }

  }

  async sendFormJuridico2($ev:any) {

    $ev.preventDefault();

    for (let c in this.valForm2.controls) {
      this.valForm2.controls[c].markAsTouched();
    }

    if (this.valForm2.valid) {

      this.substep = 3;
      this.setRandomBackground();


      this.formGroup3.controls['rut'].setValue(this.valForm.controls['rut'].value)

      if(this.formGroup3.controls['rut'].value != this.valForm.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }



    }else{
      console.log("form invalido")
      console.log(this.valForm2.value)
    }

  }

  async sendForm3($ev:any) {

    $ev.preventDefault();

    console.log($ev)

    for (let c in this.formGroup3.controls) {
      this.formGroup3.controls[c].markAsTouched();
    }

    if (this.formGroup3.valid && this.no_selecciono_banco == true) {

      this.formGroup3.value['banco_id'] = this.formGroup3.controls['banco_id'].value.id;
      this.substep = 4;
      this.setRandomBackground();



    }else{
      console.log("form invalido")
      console.log(this.formGroup3.value);
      this.formGroup3.controls['banco_id'].reset();
    }

  }

  async sendFormJuridico3($ev:any) {

    $ev.preventDefault();

        console.log($ev)

    for (let c in this.formGroup3.controls) {
      this.formGroup3.controls[c].markAsTouched();
    }

    if (this.formGroup3.valid && this.no_selecciono_banco == true) {

      this.formGroup3.value['banco_id'] = this.formGroup3.controls['banco_id'].value.id;
      this.substep = 4;
      this.setRandomBackground();



    }else{
      console.log("form invalido")
      console.log(this.formGroup3.value)
      this.formGroup3.controls['banco_id'].reset();
    }

  }

  sendForm4(){
    this.substep = 5;
    this.setRandomBackground();
  }

  verify_tercero(){
      if(this.formGroup3.controls['rut'].value != this.formGroup.controls['rut'].value){
        this.show_terceros = true;
        this.formGroup3.controls['autorizar_terceros'].setValue(true);

      }else{
        this.show_terceros = false;
        this.formGroup3.controls['autorizar_terceros'].setValue(false)
      }
  }

  //BANCOS
  bancos:any[]=[]
  filteredOptions!: Observable<any[]>;
  async load_bancos() {
    try {
      const bd: any = await this.settings.get_query(1, '/tubo-inversionista/bank/', {}, true);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:
          for (let i = 0; i < body_data.banks.length; i++) {
            this.bancos.push(body_data.banks[i]);
          }

          this.filteredOptions = this.formGroup3.controls["banco_id"].valueChanges.pipe(
            startWith(''),
            map((value) => this.filter(value))
          );

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd, "CAYO EN EL CATCH")
    }
  }

  displayFn(option: any): string {
    return option && option.name ? option.name : '';
  }

  filter(value: any) {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value?.name?.toLowerCase() || '';

    return this.bancos.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  cuentas:any[]=[];
  async load_cuentas() {
    try {
      this.cuentas = [];
      const bd: any = await this.settings.get_query(1, '/tubo-inversionista/account-type/',{},true);
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
          var body_data: any = bd._body;

          for (let i = 0; i < body_data.accounts.length; i++) {
            if (i != 1) {
              this.cuentas.push(body_data.accounts[i]);
            }
          }

          break;
        default:
          break;
      }
    } catch (bd: any) {


    }
  }

  compareFn = (o1: any, o2: any) => o1 === o2;

  origen_fondos:any=null;
  mainForm:any;
  finalizar(){

    this.step = 3;

    this.mainForm = this._formBuilder.group({
      'datos_personales': this.formGroup,
      'informacion_laboral': this.formGroup2,
      'informacion_bancaria': this.formGroup3,
      'origen_fondos': this.formGroup4,
      'declaraciones_juradas': this.formGroup5,
      'verification_code' : this.verification_code
    });

    console.log("Objeto a enviar al back", this.mainForm.value)

    this.prueba_antony(this.mainForm.value)


  }

  finalizar_juridico(){

    this.step = 3;
    this.setRandomBackground();

    this.mainForm = this._formBuilder.group({
      'datos_empresa': this.valForm,
      'representante_legal': this.valForm2,
      'informacion_bancaria': this.formGroup3,
      'origen_fondos': this.valForm4,
      'declaraciones_juradas': this.formGroup5,
      'verification_code' : this.verification_code
    });

    console.log("Objeto a enviar al back", this.mainForm.value)

    this.prueba_antony2(this.mainForm.value)


  }

  async prueba_antony(value:any){

      try {
      const bd: any = await this.settings.get_query(2, '/tubo-inversionista/persona-natural/', value);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:


          break;
        default:
          break;
      }
    } catch (bd: any) {

    }
  }

  async prueba_antony2(value:any){

      try {
      const bd: any = await this.settings.get_query(2, '/tubo-inversionista/persona-juridica/', value);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:


          break;
        default:
          break;
      }
    } catch (bd: any) {

    }
  }

  estado_civil_array:any[]=[];
  async estado_civil() {
    try {
      const bd: any = await this.settings.get_query(1, '/tubo-inversionista/estado-civil/', {}, true);
      var body_data: any = bd._body;

      switch (bd.status) {
        case 201:
        case 200:
              this.estado_civil_array = body_data?.estado_civil;

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd, "CAYO EN EL CATCH")
    }
  }

  popoverPEP = `
  Listado PEP (Persona Expuesta Políticamente):<br><br>
1. Presidente(a) de la República.<br>
2. Senadores(as), diputados(as), alcaldes(as), concejales(as), administradores(as) y Directores(as) de obras municipales.<br>
3. Ministros(as) de la Corte Suprema, ministros(as) de Cortes de Apelaciones y jueces/juezas de primera instancia.<br>
4. Ministros(as) de Estado, subsecretarios(as), gobernadores(as), delegados(as) presidenciales, consejeros(as) regionales,
   secretarios(as) y asesores(as) regionales ministeriales, embajadores(as), cónsules, jefes(as) superiores de servicio,
   tanto centralizados como descentralizados, y la o el directivo superior inmediato que deba subrogar a cada uno de ellos.<br>
5. Comandantes en jefe de las Fuerzas Armadas, director(a) General de Carabineros, director(a) General de Investigaciones,
   y todo el alto mando respectivo.<br>
6. Fiscal nacional del Ministerio Público, fiscales regionales y fiscales adjuntos.<br>
7. Fiscal nacional económico.<br>
8. Contralor(a) General de la República y contralores(as) Regionales.<br>
9. Consejeros(as) del Banco Central de Chile.<br>
10. Consejeros(as) del Consejo de Defensa del Estado.<br>
11. Ministros(as) del Tribunal Constitucional.<br>
12. Ministros(as) del Tribunal de la Libre Competencia.<br>
13. Integrantes titulares y suplentes del Tribunal de Contratación Pública.<br>
14. Consejeros(as) del Consejo de Alta Dirección Pública.<br>
15. Directores(as) y ejecutivos(as) principales de empresas públicas, según lo definido por la ley Nº18.045.<br>
16. Directores(as) de sociedades anónimas nombrados por el Estado o sus organismos.<br>
17. Miembros de las directivas de los partidos políticos.
`;


  rutKeyJuridico(event: any) {
    let value = event.target.value || '';

    value = value.replace(/[^0-9kK]/g, '').toUpperCase();

    if (value.length <= 1) {
      this.valForm2.controls['rut'].setValue(value, { emitEvent: false });
      return;
    }

    const cuerpo = value.slice(0, -1);
    const dv = value.slice(-1);
    const rutFormateado = `${cuerpo}-${dv}`;
    this.valForm2.controls['rut'].setValue(rutFormateado, { emitEvent: false });
  }

  rutKeyJuridico1(event: any) {
    let value = event.target.value || '';

    value = value.replace(/[^0-9kK]/g, '').toUpperCase();

    if (value.length <= 1) {
      this.valForm.controls['rut'].setValue(value, { emitEvent: false });
      return;
    }

    const cuerpo = value.slice(0, -1);
    const dv = value.slice(-1);
    const rutFormateado = `${cuerpo}-${dv}`;
    this.valForm.controls['rut'].setValue(rutFormateado, { emitEvent: false });
  }

  display_spinner:boolean=false;
  rutKeyNatural(event: any) {
    let value = event.target.value || '';

    value = value.replace(/[^0-9kK]/g, '').toUpperCase();

    if (value.length <= 1) {
      this.formGroup.controls['rut'].setValue(value, { emitEvent: false });
      return;
    }

    const cuerpo = value.slice(0, -1);
    const dv = value.slice(-1);
    const rutFormateado = `${cuerpo}-${dv}`;
    this.formGroup.controls['rut'].setValue(rutFormateado, { emitEvent: false });
  }

  success_rut:boolean=false;
  success_email:boolean=false;
  async checkRutNatural($e: any) {

    let rut = $e.target.value;

      try {

        this.success_rut = false;

        this.display_spinner = true;
        const bd: any = await this.settings.get_query(1, 'tubo-inversionista/validar-rut/?verification_code='+this.verification_code+'&rut='+rut, true);
        var body_data: any =bd._body;
        switch (bd.status) {
          case 200:

            //si cayo en el 200 significa que el rut esta valido.
            this.success_rut = true;
            

          break;
          default:
            this.formGroup.controls['rut'].setErrors({incorrect: true});
          break;
        }
      } catch (error: any) {

        let msg = error?.error?.message;

        if(msg.includes('rut inválido')){
          this.formGroup.controls['rut'].setErrors({invalid: true});
        }

        if(msg.includes('ya existe asociado')){
          this.formGroup.controls['rut'].setErrors({incorrect: true});
          this.open_alert("El RUT ya se encuentra registrado.");
        }

      } finally {
        this.display_spinner = false;
      }

  }

  async checkRutJuridico($e: any) {

    let rut = $e.target.value;

      try {

        this.success_rut = false;

        this.display_spinner = true;
        const bd: any = await this.settings.get_query(1, 'tubo-inversionista/validar-rut/?verification_code='+this.verification_code+'&rut='+rut, true);
        var body_data: any =bd._body;
        switch (bd.status) {
          case 200:

            //si cayo en el 200 significa que el rut esta valido.
            this.success_rut = true;
            

          break;
          default:
            this.valForm.controls['rut'].setErrors({incorrect: true});
          break;
        }
      } catch (error: any) {

        let msg = error?.error?.message;

        if(msg.includes('rut inválido')){
          this.valForm.controls['rut'].setErrors({invalid: true});
        }

        if(msg.includes('ya existe asociado')){
          this.valForm.controls['rut'].setErrors({incorrect: true});
          this.open_alert("El RUT ya se encuentra registrado.");
        }

      } finally {
        this.display_spinner = false;
      }

  }

  spinner_validate_email:boolean=false;
  async validateEmail($e: any) {
    let email = $e.target.value;
    this.spinner_validate_email = true;

    try {

      this.success_email = false;

      const bd: any = await this.settings.get_query(1, 'tubo-inversionista/validar-email/?verification_code='+this.verification_code+'&email='+email, true);
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:

          this.success_email = true;

        break;
        default:
          this.formGroup.controls['email'].setErrors({invalid: true});

        break;
      }
    } catch (bd: any) {
      this.formGroup.controls['email'].setErrors({invalid: true});
      this.open_alert("El Email ya se encuentra registrado.");
    } finally {
      this.spinner_validate_email = false;
    }

  }

  async validateEmailJuridico($e: any) {
    let email = $e;
    this.spinner_validate_email = true;

    try {

      this.success_email = false;

      const bd: any = await this.settings.get_query(1, 'tubo-inversionista/validar-email/?verification_code='+this.verification_code+'&email='+email, true);
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:

          this.success_email = true;

        break;
        default:
          this.valForm.controls['email'].setErrors({invalid: true});

        break;
      }
    } catch (bd: any) {
      this.valForm.controls['email'].setErrors({invalid: true});
      this.open_alert("El Email ya se encuentra registrado.");
    } finally {
      this.spinner_validate_email = false;
    }

  }

  open_alert(text:string){
    this.dialog.open(DialogStatus, {
        autoFocus: false,
        data: {

        title: '¡Atención!',
        message: text,
        type: 'warning'
      }
  });
  }

  loadingFicha:boolean=false;
  async getFicha() {


    try {

      this.loadingFicha = true;

      const bd: any = await this.settings.get_query(1, 'tubo-inversionista/obtener-info-preficha/?verification_code='+this.verification_code, true);
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:


        console.log(body_data)

        //persona natural
        this.formGroup.controls['rut'].setValue(body_data?.rut);
        this.formGroup.controls['name'].setValue(body_data?.business_name);
        this.formGroup.controls['email'].setValue(body_data?.email);
        this.formGroup.controls['phone'].setValue(this.cleanToNumbers(body_data?.phone));
        this.formGroup.controls['direccion'].setValue(body_data?.direccion);

        //this.formGroup.controls['estado_civil'].setValue(body_data?.estado_civil?.id);


        //persona juridica
        this.valForm.controls['rut'].setValue(body_data?.rut);
        this.valForm.controls['razon_social'].setValue(body_data?.business_name);
        this.valForm.controls['email'].setValue(body_data?.email);
        this.valForm.controls['direccion'].setValue(body_data?.direccion);

        if(body_data?.rut){
          this.success_rut = true;
        }

        if(body_data?.email){
          this.success_email = true;
        }

        break;
        default:


        break;
      }
    } catch (bd: any) {

    } finally {
      this.loadingFicha = false;
    }

  }

  cleanToNumbers(value: string): string {
    if (!value) return '';
    return value.replace(/\D+/g, '');
  }

  regions: any[] = [];
  districts: any[] = [];
  filteredDistricts: any[] = [];
  filteredDistrictsEmpresa: any[] = [];
  filteredDistrictsRepLegal: any[] = [];
  async getDistricts(){
    try {

      const bd: any = await this.settings.get_query(1, "/address-info-form/");
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:
          this.districts = body_data.success.comunas;
          this.regions = body_data.success.regiones;

          this.formGroup.get('region_id')?.valueChanges.subscribe((regionId) => {
            this.filteredDistricts = this.districts.filter(d => d.region_id === regionId);
          });

          this.valForm.get('region_empresa_id')?.valueChanges.subscribe((regionId) => {
            this.filteredDistrictsEmpresa = this.districts.filter(d => d.region_id === regionId);
          });

          this.valForm2.get('region_id')?.valueChanges.subscribe((regionId) => {
            this.filteredDistrictsRepLegal = this.districts.filter(d => d.region_id === regionId);
          });

        break;

        default:
        break;
      }

    } catch (bd:any) {
      console.log(bd);
    }
  }

  get fullPhone(): string {
    const code = this.formGroup.get('phone_code')?.value ?? '';
    const number = this.formGroup.get('phone_number')?.value ?? '';
    return `${code}${number}`;
  }

  COUNTRIES: Country[]=[];
  filteredCountries: Country[] = [];
  async getPhonePrefix(){
    try {

      const bd: any = await this.settings.get_query(1, "backoffice/phone-prefixes/");
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:


          this.COUNTRIES = body_data.info;
          this.filteredCountries = [...this.COUNTRIES];

        break;

        default:
        break;
      }

    } catch (bd:any) {
      console.log(bd);
    }
  }

  no_selecciono_banco:boolean=false;
  selecciono_banco($event:any){

    this.no_selecciono_banco = true;

  }

}

interface Country {
  name: string;
  flag: string;
  dialCode: string;
  code: string;
}